import { css } from 'styled-components';

import {
  CommonTheme,
  FontFamily,
  FontSizePropKey,
  FontWeightType,
  LetterSpacingKey,
} from 'app/shared/theme';

export interface WithFontProps {
  fontSize?: FontSizePropKey;
  fontWeight?: FontWeightType;
  fontStyle?: string;
  fontFamily?: FontFamily;
  lineHeight?: string;
  letterSpacing?: LetterSpacingKey;
  textTransform?: string;
  textDecoration?: string;
  textAlign?: string;
  textWrap?: string;
  textOverflow?: string;
  wordBreak?: string;
}

export interface WithFontCSSProps extends WithFontProps {
  theme: CommonTheme;
}

function responsiveFontSizeCSS({ theme, fontSize }: WithFontCSSProps) {
  if (fontSize) {
    const fontSizeResponsive = theme.fontSizes[fontSize as FontSizePropKey];

    if (fontSizeResponsive) {
      return css`
        ${theme.media.mobile`
              font-size: ${fontSizeResponsive.mobile};
            `};

        ${theme.media.smallDesktop`
              font-size: ${fontSizeResponsive.desktop};
            `};
      `;
    }
  }

  return css`
    ${theme.media.mobile`
        font-size: ${theme.fontSizes.root.mobile};
      `};

    ${theme.media.smallDesktop`
        font-size: ${theme.fontSizes.root.desktop};
      `};
  `;
}

export const withFontCSS = ({
  theme,
  fontSize = 'fontSize100' as FontSizePropKey,
  fontWeight = 'regular' as FontWeightType,
  fontStyle = 'normal',
  fontFamily = 'regular',
  lineHeight,
  letterSpacing,
  textTransform = 'none',
  textDecoration = 'none',
  textAlign = 'unset',
  textWrap = 'unset',
  textOverflow = 'unset',
  wordBreak,
}: WithFontCSSProps) => css`
  ${responsiveFontSizeCSS({ theme, fontSize })}
  font-family: ${theme.fonts[fontFamily]} !important;

  text-transform: ${textTransform};
  text-decoration: ${textDecoration};
  text-align: ${textAlign};
  text-wrap: ${textWrap};
  text-overflow: ${textOverflow};
  ${wordBreak && `word-break: ${wordBreak};`}

  letter-spacing: ${
    letterSpacing
      ? theme.letterSpacings[letterSpacing]
      : textTransform === 'uppercase'
        ? theme.letterSpacings.uppercase
        : theme.letterSpacings.default
  };
  word-wrap: break-word;

  font-weight: ${theme.fontWeights[fontWeight]};

  font-style: ${fontStyle};

  line-height: ${lineHeight || theme.fontSizes.rootLineHeight};

  -webkit-font-smoothing: antialiased;
`;
